import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import format from '../../helpers/format'
import Styles from './FinanceFundScore.css'

@CSSModules(Styles, {allowMultiple: true})
export default class FinanceFundScore extends Component {
  static propTypes = {
    score: PropTypes.string.isRequired,
    grade: PropTypes.number.isRequired,
  }
  constructor(props){
    super(props)
  }

  render() {
    const { score, grade } = this.props
    let _score = format.number(score, false, false, 1)
    if (parseFloat(_score) === 0 && parseFloat(score)>0) {
      _score = '<0.1'
    } else if (_score.slice(-1)==='0' && parseFloat(score)<=0) {
      _score = format.number(score, false, false, 0)
    }
    //
    return (
      <div styleName={'finance-fund-score-'+grade}>
        {_score}
      </div>
    )
  }
}

